// import React from "react";
import React from "react";
// import Research_pages from "../Page_Layouts/Research_pages";
import hero from "../../Images/Multimodal/hero.webp";
import card1 from "../../Images/Multimodal/card1.webp";
import card2 from "../../Images/Multimodal/card2.webp";
// import card3 from "../Images/2D/card3.webp";
// import card4 from "../Images/2D/card4.webp";
// import card6 from "../Images/2D/card6.webp";

import Cards from "../../Components/Research/Cards_main.js";
import { Link } from "react-router-dom";
import Navbar from "../../Components/Common/Navbar.js";
import BackToTop from "../../Components/Common/BackToTop.js";
// import Breadcrumbs from "../Components/Common/Breadcrumbs";
import Hero from "../../Components/Common/Hero.js"

import Footer from "../Footer.js";

function Multimodal() {
  return (
    <>
      <div className="main pages_background  min-vh-100 w-100">
        <BackToTop />
        <Navbar />

        <br />
        <br />
        <br />

        <Hero
        title="Multimodal Data Acquisition and Processing"
        img={hero}
        />

        <div className="">
          <div className="container" style={{ paddingBlock: "1em", marginTop: '1em' }}>
            {/* <Breadcrumbs /> */}

            <div className="content-font-size" style={{ textAlign: "justify" }}>
              <p>
                Our goal is to advance the field of multimodal acquisition and
                processing by pushing the boundaries of knowledge and developing
                novel techniques and methodologies. We collaborate with academic
                institutions, industry partners, and stakeholders to create
                meaningful impact in various domains.
              </p>

              <p>
                Explore our website to learn more about our ongoing research
                projects, publications, and collaborations. Contact us today to
                discuss potential partnerships, research opportunities, or to
                explore how our expertise in multimodal acquisition and
                processing can benefit your specific needs. Together, let's
                unlock the power of integrating multiple modalities and gain
                deeper insights into complex systems.
              </p>
            </div>
          </div>
        </div>

        <div style={{ backgroundColor: "", paddingBlock: "1em" }}>
          <div className="container">
            <div className="row gy-5">
              <div className="col-lg-4 col-md-6 gx-md-4 gx-xxl-4 gx-0 justify-content-center">
                <Link
                  // to="/Research/3d/Three_Dimensional_Page1"
                  style={{ textDecoration: "none" }}
                  className="link"
                >
                  <Cards
                    id="01"
                    img={card1}
                    title="Sensor Fusion and Integration"
                    // desc="We delve into the integration of data from different sensors and modalities, such as images, audio, video, depth, and physiological signals. Our research aims to develop robust techniques for fusing and integrating multimodal data to obtain a more comprehensive and accurate representation of the underlying phenomenon."
                  />
                </Link>
              </div>

              <div className="col-lg-4 col-md-6 gx-md-4 gx-xxl-4 gx-0 justify-content-center">
                <Link
                  // to="/Research/3d/Three_Dimensional_Page2"
                  style={{ textDecoration: "none" }}
                  className="link"
                >
                  <Cards
                    id="02"
                    img={card2}
                    title="Multimodal Data Alignment and Registration"
                    // desc="Aligning and registering multimodal data is a crucial step in multimodal analysis. We explore techniques to align and synchronize data from multiple sensors or modalities, ensuring temporal and spatial coherence. This enables meaningful analysis and extraction of complementary information from multimodal data."
                  />
                </Link>
              </div>

              <div className="col-lg-4 col-md-6 gx-md-4 gx-xxl-4 gx-0 justify-content-center">
                <Link
                  // to="/Research/3d/Three_Dimensional_Page3"
                  style={{ textDecoration: "none" }}
                  className="link"
                >
                  <Cards
                    id="03"
                    // img={card3}
                    title="Multimodal Feature Extraction"
                    // desc="We specialize in extracting informative features from multimodal data. Our research focuses on developing algorithms and techniques to capture and represent relevant information from each modality. This enables the fusion of complementary features and facilitates multimodal analysis, classification, and recognition tasks."
                  />
                </Link>
              </div>

              <div className="col-lg-4 col-md-6 gx-md-4 gx-xxl-4 gx-0 justify-content-center">
                <Link
                  // to="/Research/3d/Three_Dimensional_Page4"
                  style={{ textDecoration: "none" }}
                  className="link"
                >
                  <Cards
                    id="04"
                    // img={card4}
                    title="Multimodal Data Fusion and Integration"
                    // desc="We investigate methods for fusing and integrating multimodal data at various levels, including feature-level fusion, decision-level fusion, and semantic-level fusion. Our research aims to leverage the complementary nature of different modalities to enhance the understanding and interpretation of complex systems."
                  />
                </Link>
              </div>

              <div className="col-lg-4 col-md-6 gx-md-4 gx-xxl-4 gx-0 justify-content-center">
                <Link
                  // to="/Research/3d/Three_Dimensional_Page5"
                  style={{ textDecoration: "none" }}
                  className="link"
                >
                  <Cards
                    id="05"
                    // img={card5}
                    title="Multimodal Machine Learning and Deep Learning"
                    // desc="We apply machine learning and deep learning techniques to multimodal data analysis. Our research focuses on developing algorithms and architectures that can effectively handle and leverage multimodal information for tasks such as object recognition, sentiment analysis, action recognition, and anomaly detection."
                  />
                </Link>
              </div>

              <div className="col-lg-4 col-md-6 gx-md-4 gx-xxl-4 gx-0 justify-content-center">
                <Link
                  // to="/Research/3d/Three_Dimensional_Page6"
                  style={{ textDecoration: "none" }}
                  className="link"
                >
                  <Cards
                    id="06"
                    // img={card6}
                    title="Multimodal Data Visualization and Interaction"
                    // desc="Effective visualization and interaction methods are crucial for multimodal data analysis. We explore techniques for visualizing and presenting multimodal data in an intuitive and interpretable manner. This enables users to explore and interact with the integrated multimodal data, facilitating deeper insights and knowledge discovery."
                  />
                </Link>
              </div>

              <div className="col-lg-4 col-md-6 gx-md-4 gx-xxl-4 gx-0 justify-content-center">
                <Link
                  // to="/Research/3d/Three_Dimensional_Page7"
                  style={{ textDecoration: "none" }}
                  className="link"
                >
                  <Cards
                    id="06"
                    // img={card7}
                    title="Applications in Various Domains"
                    // desc="Multimodal acquisition and processing find applications in diverse fields, such as healthcare, robotics, surveillance, human-computer interaction, smart environments, and multimedia analysis. We collaborate with domain experts to address specific challenges and requirements in these areas, driving innovation and creating practical solutions."
                  />
                </Link>
              </div>
            </div>
          </div>
        </div>

        <Footer />
      </div>
    </>
  );
}

export default Multimodal;
